import './ancillary-rollup-bundles/facts-and-figures/scss/main.scss'

import buildClinical from './ancillary-rollup-bundles/facts-and-figures/imports/builders/buildClinical'
import buildEduGraduate from './ancillary-rollup-bundles/facts-and-figures/imports/builders/buildEduGraduate'
import buildEduHome from './ancillary-rollup-bundles/facts-and-figures/imports/builders/buildEduHome'
import buildEduMedicalStudent from './ancillary-rollup-bundles/facts-and-figures/imports/builders/buildEduMedicalStudent'
import buildEduResidents from './ancillary-rollup-bundles/facts-and-figures/imports/builders/buildEduResidents'
import buildEduUndergrad from './ancillary-rollup-bundles/facts-and-figures/imports/builders/buildEduUndergrad'
import buildFaculty from './ancillary-rollup-bundles/facts-and-figures/imports/builders/buildFaculty'
import buildHome from './ancillary-rollup-bundles/facts-and-figures/imports/builders/buildHome'
import buildResearch from './ancillary-rollup-bundles/facts-and-figures/imports/builders/buildResearch'

// run things once all is loaded
document.addEventListener('DOMContentLoaded', (event) => {
  // The entire show hinges on the existence of an element on the page with and ID of #ff-config that contains a data-pagelayout attribute
  const ffInfoElement = document.getElementById('ff-config')

  // If we found it, switch the data attr to figure out which 
  // <div id="ff-config" data-pagelayout="home"></div>
  if(ffInfoElement) {
    switch(ffInfoElement.dataset.pagelayout) {
      case 'home':
        buildHome()
        break
      case 'clinical':
        buildClinical()
        break
      case 'eduGraduate':
        buildEduGraduate()
        break
      case 'eduHome':
        buildEduHome()
        break
      case 'eduMedicalStudent':
        buildEduMedicalStudent()
        break
      case 'eduResidents':
        buildEduResidents()
        break
      case 'eduUndergrad':
        buildEduUndergrad()
        break
      case 'faculty':
        buildFaculty()
        break
      case 'research':
        buildResearch()
        break
      default:
        console.error('No #ff-info element found. Are you sure this is the template you want to be using?')
    }
  }
})